(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["greenville-consultation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-greenville-consultation]');
    if (sections.length === 0) return;

    const requiresVehicleDetails = (value) =>
      value === 'Build Quote' || value === 'Parts + Installation' || value === 'Repair / Diagnostic';

    const fieldControl = (field) => field.querySelector('input, select, textarea');

    const setFieldState = (field, invalid) => {
      const control = fieldControl(field);
      field.classList.toggle('go-field--invalid', invalid);

      if (!control) return;

      if (invalid) {
        control.setAttribute('aria-invalid', 'true');
      } else {
        control.removeAttribute('aria-invalid');
      }
    };

    sections.forEach((section) => {
      if (section.dataset.goConsultationReady === 'true') return;

      const form = section.querySelector('form');
      const inquiryType = section.querySelector('[data-inquiry-type]');
      const vehicleGroup = section.querySelector('[data-vehicle-fields]');
      const vehicleFields = Array.from(section.querySelectorAll('[data-vehicle-field]'));
      const summary = section.querySelector('[data-error-summary]');
      const summaryList = section.querySelector('[data-error-list]');

      if (!form || !inquiryType || !vehicleGroup || !summary || !summaryList) return;

      const toggleVehicleFields = () => {
        const showVehicleDetails = requiresVehicleDetails(inquiryType.value);
        vehicleGroup.hidden = !showVehicleDetails;

        vehicleFields.forEach((field) => {
          const control = fieldControl(field);
          if (!control) return;

          control.required = showVehicleDetails;

          if (!showVehicleDetails) {
            setFieldState(field, false);
            control.value = '';
          }
        });
      };

      const visibleRequiredFields = () =>
        Array.from(form.querySelectorAll('[data-required], [data-vehicle-field]')).filter((field) => {
          if (field.closest('[hidden]')) return false;
          const control = fieldControl(field);
          return Boolean(control) && control.required;
        });

      const validateField = (field) => {
        const control = fieldControl(field);
        if (!control) return true;

        const isValid = control.checkValidity();
        setFieldState(field, !isValid);
        return isValid;
      };

      const clearSummary = () => {
        summary.hidden = true;
        summaryList.innerHTML = '';
      };

      const showSummary = (invalidFields) => {
        summaryList.innerHTML = '';

        invalidFields.forEach((field) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const control = fieldControl(field);
          const label = field.dataset.fieldLabel || 'This field';
          const message = field.dataset.errorMessage || 'Please review this field.';

          link.href = `#${control.id}`;
          link.textContent = `${label}: ${message}`;
          item.appendChild(link);
          summaryList.appendChild(item);
        });

        summary.hidden = false;
      };

      toggleVehicleFields();

      inquiryType.addEventListener('change', () => {
        clearSummary();
        toggleVehicleFields();
      });

      Array.from(form.querySelectorAll('[data-required], [data-vehicle-field]')).forEach((field) => {
        const control = fieldControl(field);
        if (!control) return;

        control.addEventListener('blur', () => validateField(field));
        control.addEventListener('input', () => {
          if (field.classList.contains('go-field--invalid')) {
            validateField(field);
          }
        });
      });

      form.addEventListener('submit', (event) => {
        const invalidFields = visibleRequiredFields().filter((field) => !validateField(field));

        if (invalidFields.length === 0) {
          clearSummary();
          if (window.GOTrack) {
            window.GOTrack({
              event: 'go_form_submit',
              go_action: 'consultation-submit',
              go_label: inquiryType.value || 'Contact form',
            });
          }
          return;
        }

        event.preventDefault();
        showSummary(invalidFields);
        invalidFields[0].querySelector('input, select, textarea')?.focus();
      });

      section.dataset.goConsultationReady = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["greenville-events-board"] && !Shopify.designMode) return;
  try {
    
  class GreenvilleEventsBoard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.eventsReady === 'true') return;

      this.filters = Array.from(this.querySelectorAll('[data-event-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-event-card]'));
      this.emptyState = this.querySelector('[data-events-empty]');
      this.state = { status: 'all', difficulty: 'all' };

      if (this.filters.length === 0 || this.cards.length === 0) return;

      this.filters.forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.dataset.filterGroup;
          const value = button.dataset.filterValue;
          this.state[group] = value;

          this.filters
            .filter((item) => item.dataset.filterGroup === group)
            .forEach((item) => item.classList.toggle('is-active', item === button));

          this.applyFilters();
        });
      });

      this.applyFilters();
      this.dataset.eventsReady = 'true';
    }

    applyFilters() {
      let visibleCards = 0;

      this.cards.forEach((card) => {
        const matchesStatus =
          this.state.status === 'all' || card.dataset.status === this.state.status;
        const matchesDifficulty =
          this.state.difficulty === 'all' || card.dataset.difficulty === this.state.difficulty;
        const shouldShow = matchesStatus && matchesDifficulty;

        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCards += 1;
        }
      });

      if (this.emptyState) {
        this.emptyState.hidden = visibleCards !== 0;
      }
    }
  }

  if (!customElements.get('greenville-events-board')) {
    customElements.define('greenville-events-board', GreenvilleEventsBoard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["greenville-instagram-proof"] && !Shopify.designMode) return;
  try {
    
  class GreenvilleInstagramProof extends HTMLElement {
    connectedCallback() {
      const processEmbeds = () => window.instgrm?.Embeds?.process();

      if (window.instgrm?.Embeds?.process) {
        processEmbeds();
        return;
      }

      let script = document.getElementById('greenville-instagram-embed-script');

      if (script) {
        if (script.dataset.loaded === 'true') {
          processEmbeds();
        } else {
          script.addEventListener('load', processEmbeds, { once: true });
        }
        return;
      }

      script = document.createElement('script');
      script.id = 'greenville-instagram-embed-script';
      script.async = true;
      script.src = 'https://www.instagram.com/embed.js';
      script.addEventListener(
        'load',
        () => {
          script.dataset.loaded = 'true';
          processEmbeds();
        },
        { once: true }
      );
      document.head.appendChild(script);
    }
  }

  if (!customElements.get('greenville-instagram-proof')) {
    customElements.define('greenville-instagram-proof', GreenvilleInstagramProof);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["greenville-review-proof"] && !Shopify.designMode) return;
  try {
    
  class GreenvilleReviewProof extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('.go-review-proof__video');

      if (!video) return;

      const allowMotion = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
      const desktopView = window.matchMedia('(min-width: 750px)').matches;

      if (!allowMotion || !desktopView) return;

      video.play().catch(() => {});
    }
  }

  if (!customElements.get('greenville-review-proof')) {
    customElements.define('greenville-review-proof', GreenvilleReviewProof);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["greenville-review-wall"] && !Shopify.designMode) return;
  try {
    
  class GreenvilleReviewWall extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-review-more]');
      const hiddenCards = () => [...this.querySelectorAll('[data-review-card][hidden]')];

      if (!button) return;

      button.addEventListener('click', () => {
        hiddenCards().slice(0, 12).forEach((card) => card.removeAttribute('hidden'));

        if (hiddenCards().length === 0) {
          button.hidden = true;
        }
      });
    }
  }

  if (!customElements.get('greenville-review-wall')) {
    customElements.define('greenville-review-wall', GreenvilleReviewWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
